import React from 'react';
import './Commentator.css';

const comments = [
    // Общие комментарии
    "Отличный ход!",
    "Интересная стратегия!",
    "Хмм, неожиданно...",
    "Сильная позиция!",
    "Рискованный ход!",
    "Классика жанра!",
    "Нестандартное решение!",
    "Очень умно!",
    "Тактически верно!",
    "Смелый выбор!",
    
    // Шуточные комментарии
    "Компьютер в шоке!",
    "Этот ход как удар молнии!",
    "Даже я не ожидал такого!",
    "Компьютер плачет в уголке!",
    "Этот ход достоин Оскара!",
    "Компьютер ищет калькулятор!",
    "Даже роботы в восторге!",
    "Этот ход как шоколад - сладкий!",
    "Компьютер завис от удивления!",
    "Этот ход как пицца - идеален!",
    
    // Атакующие комментарии
    "Атака началась!",
    "Наступаем!",
    "Вперёд к победе!",
    "Сильный удар!",
    "Компьютер в обороне!",
    "Давим на противника!",
    "Отличная атака!",
    "Компьютер отступает!",
    "Превосходная атака!",
    "Противник в панике!",
    
    // Защитные комментарии
    "Хорошая защита!",
    "Стойко держимся!",
    "Отличный блок!",
    "Компьютер не пройдёт!",
    "Крепкая оборона!",
    "Стойкий как скала!",
    "Защита на высоте!",
    "Не сдаём позиции!",
    "Компьютер в тупике!",
    "Надёжная защита!",
    
    // Комментарии к победе
    "Победа близко!",
    "Ещё чуть-чуть!",
    "Почти у цели!",
    "Компьютер дрожит!",
    "Победа на горизонте!",
    "Последний рывок!",
    "Финальный удар!",
    "Компьютер сдаётся!",
    "Победа в кармане!",
    "Последний шаг!",
    
    // Комментарии к проигрышу
    "Опасная ситуация!",
    "Нужно быть осторожнее!",
    "Компьютер силён!",
    "Сложная позиция!",
    "Требуется концентрация!",
    "Компьютер не дремлет!",
    "Нужно собраться!",
    "Сложный момент!",
    "Компьютер давит!",
    "Требуется защита!",
    
    // Шуточные комментарии к ходам
    "Этот ход как супергерой!",
    "Компьютер в панике!",
    "Даже я впечатлён!",
    "Этот ход как ракета!",
    "Компьютер ищет инструкцию!",
    "Этот ход как фейерверк!",
    "Даже роботы аплодируют!",
    "Этот ход как конфетка!",
    "Компьютер завис!",
    "Этот ход как сюрприз!",
    
    // Комментарии к неожиданным ходам
    "Вот это поворот!",
    "Неожиданно и сильно!",
    "Компьютер в замешательстве!",
    "Гениальное решение!",
    "Такого никто не ждал!",
    "Компьютер перезагружается!",
    "Блестящий ход!",
    "Этот ход как фокус!",
    "Компьютер в шоке!",
    "Невероятный ход!",
    
    // Комментарии к повторяющимся ходам
    "Повторение - мать учения!",
    "Стратегия работает!",
    "Компьютер учится!",
    "Проверенная тактика!",
    "Надёжный подход!",
    "Компьютер в растерянности!",
    "Классика работает!",
    "Этот ход как часы!",
    "Компьютер в тупике!",
    "Проверенный метод!",
    
    // Комментарии к длительным играм
    "Игра затягивается!",
    "Интересная партия!",
    "Компьютер устал!",
    "Напряжённая борьба!",
    "Ничья не за горами!",
    "Компьютер задумался!",
    "Сложная ситуация!",
    "Этот ход как шахматный!",
    "Компьютер в раздумьях!",
    "Интересная позиция!"
];

const winningComments = [
    "Поздравляю! Даже калькулятор иногда выигрывает!",
    "Ура! Компьютер, наверное, был в отпуске!",
    "Невероятно! Компьютер, наверное, перегрелся!",
    "Победа! Даже я не ожидал такого подвоха!",
    "Браво! Компьютер, наверное, забыл зарядиться!",
    "Отличная игра! Компьютер, наверное, обновился в неподходящий момент!",
    "Поздравляю! Компьютер, наверное, играл одной рукой!",
    "Ура! Компьютер, наверное, думал, что это шахматы!",
    "Победа! Компьютер, наверное, считал до пяти!",
    "Браво! Компьютер, наверное, играл с завязанными глазами!"
];

const losingComments = [
    "Не расстраивайся, даже калькулятор иногда ошибается!",
    "Компьютер просто жульничал, я видел!",
    "Может, просто перезагрузим компьютер?",
    "Даже роботы иногда выигрывают!",
    "Не переживай, у меня тоже не всегда получается!",
    "Компьютер, наверное, читал книжку по стратегии!",
    "Может, просто отключим ему интернет?",
    "Даже я не ожидал такого подвоха!",
    "Компьютер, наверное, читер какой-то!",
    "Не расстраивайся, у меня тоже руки из плеч растут!"
];

const drawComments = [
    "Ничья! Человек и машина - лучшие друзья!",
    "Дружба победила! Компьютер и человек на равных!",
    "Великолепная ничья! Человек и робот - братья навек!",
    "Игра вничью! Компьютер и человек - идеальная пара!",
    "Ничья! Человек и машина - два сапога пара!",
    "Дружеская ничья! Компьютер и человек - не разлей вода!",
    "Игра вничью! Человек и робот - как две капли воды!",
    "Ничья! Компьютер и человек - как братья-близнецы!",
    "Дружеская ничья! Человек и машина - как две половинки одного целого!",
    "Игра вничью! Компьютер и человек - как две стороны одной медали!",
    "Ничья! Человек и робот - как два крыла одной птицы!",
    "Дружеская ничья! Компьютер и человек - как два сапога пара!",
    "Игра вничью! Человек и машина - как две звезды на небе!",
    "Ничья! Компьютер и человек - как два орешка в скорлупке!",
    "Дружеская ничья! Робот и человек - как два цветка в букете!"
];

function Commentator({ lastMove }) {
    const [comment, setComment] = React.useState("Добро пожаловать в игру!");
    const [showComment, setShowComment] = React.useState(false);

    React.useEffect(() => {
        if (lastMove && lastMove.player === 'X') {
            if (lastMove.gameOver) {
                // Если игра закончилась победой игрока
                const randomIndex = Math.floor(Math.random() * winningComments.length);
                setComment(winningComments[randomIndex]);
            } else {
                // Обычный ход игрока
                const randomIndex = Math.floor(Math.random() * comments.length);
                setComment(comments[randomIndex]);
            }
        } else if (lastMove && lastMove.player === 'O' && lastMove.gameOver) {
            // Если игра закончилась победой компьютера
            const randomIndex = Math.floor(Math.random() * losingComments.length);
            setComment(losingComments[randomIndex]);
        } else if (lastMove && lastMove.gameOver) {
            // Если игра закончилась вничью
            const randomIndex = Math.floor(Math.random() * drawComments.length);
            setComment(drawComments[randomIndex]);
        }
        
        setShowComment(true);
        
        // Скрываем комментарий через 10 секунд
        const timer = setTimeout(() => {
            setShowComment(false);
        }, 10000);
        
        return () => clearTimeout(timer);
    }, [lastMove]);

    return (
        <div className="commentator-container">
            <div className={`speech-bubble ${showComment ? 'show' : ''}`}>
                {comment}
            </div>
            <img 
                src="/commentator.svg" 
                alt="Commentator" 
                className="commentator-image"
            />
        </div>
    );
}

export default Commentator; 